module.exports = __webpack_public_path__ + "img/5988636.d2287823.jpg";